// extracted by mini-css-extract-plugin
module.exports = {"button":"AccordionItem_button__bIUDp","content":"AccordionItem_content__K_t3O","open":"AccordionItem_open__pWhus"};